export default function useSwitchFilter(items: (object & { id: string })[]) {
  const currentActiveFilterId = ref<string | null>(items[0]?.id ?? null);

  return {
    setActiveFilter,
    currentActiveFilterId,
  };

  function setActiveFilter(itemId: string | null) {
    currentActiveFilterId.value = itemId;
  }
}
